import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { retry, catchError } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { SettingService } from './setting.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private http: HttpClient, private settingsService: SettingService) { }
  params = { idSession: '', nombre: '', app: '', usuarioWeb: '', bloqueos: '' };
  url = this.settingsService.settings.ipFyService;
  ipiFy = this.settingsService.settings.ipFyService;
  pocaeHitorial = this.settingsService.settings.pocaeHistorial;
  error: any;

  private session = new BehaviorSubject(this.params);
  currentSession = this.session.asObservable();

  getSessionSync() {
    // intenta primero el BehaviorSubject
    const current = this.session.getValue();
    // si está vacío o sin idSession, intenta cargar desde localStorage para compatibilidad
    if (!current || !current.idSession) {
      const idUser = localStorage.getItem('sesIdUsuario') || '';
      const idSession = localStorage.getItem('sesIdsesion') || '';
      const sesIdEmpresa = localStorage.getItem('nIdEmpresa') || '0';
      if (!idSession) {
        return null; // no hay sesión
      }
      return {
        idSession,
        nombre: current?.nombre || '',
        app: current?.app || '',
        usuarioWeb: current?.usuarioWeb || '',
        bloqueos: current?.bloqueos || '',
        nNumUsuario: parseInt(idUser || '0', 10),
        nIdEmpresa: parseInt(sesIdEmpresa || '0', 10),
        sKsi: idSession,
        sHost: '127.0.0.1'
      };
    }
    
    // si existe en BehaviorSubject, devuélvelo adaptado
    return {
      idSession: current.idSession,
      nNumUsuario: parseInt(current.usuarioWeb || '0', 10),
      nIdEmpresa: parseInt(current.bloqueos || '0', 10), // si usas campos distintos, ajusta
      sKsi: current.idSession,
      sHost: '127.0.0.1',
      nombre: current.nombre
    };
  }

   // Alternativa: método que devuelve el objeto usuario en la estructura que espera backend
  getUsuarioPayload() {
    const s = this.getSessionSync();
    if (!s) return null;
    return {
      nIdEmpresa: s.nIdEmpresa || 0,
      nNumUsuario: s.nNumUsuario || 0,
      sKsi: s.sKsi || '',
      sHost: s.sHost || '127.0.0.1'
    };
  }

  publicIp() {
    return this.http.get(this.ipiFy);
  }

  addSession(idSession: string, nombre: string, hostName: string, usuarioWeb: string, bloqueos: any) {
    this.params = { idSession: idSession, nombre: nombre, app: hostName, usuarioWeb: usuarioWeb, bloqueos: bloqueos };
    this.session.next(this.params)
  }

  iniciar(json) {
    return this.http.post(this.url + '/RCAEBack/pocae/usuario/login', JSON.stringify(json))
      .pipe(catchError(this.error))
  }

  recuperar(json) {
    return this.http.post(this.url + "/RCAEBack/pocae/usuario/recuperarPassword", JSON.stringify(json))
      .pipe(retry(4), catchError(this.error));
  }
  resetPass(json) {
    return this.http.post(this.url + "/RCAEBack/pocae/usuario/reiniciarPassword", JSON.stringify(json))
      .pipe(retry(4), catchError(this.error))
  }

  crear(json) {
    return this.http.post(this.url, JSON.stringify(json))
      .pipe(retry(4), catchError(this.error));
  }

  validaCorreo(json) {
    return this.http.post(this.url + "/RCAEBack/pocae/usuario/verificar", JSON.stringify(json))
      .pipe(catchError(this.error))
  }

  actualizaIndValido(json) {
    return this.http.post(this.url + "/RCAEBack/pocae/usuario/validarToken", JSON.stringify(json))
      .pipe(catchError(this.error))
  }
}
